import { Typography } from "@mui/material";
import React from "react";

export default function Topic({ children }) {
  return (
    <Typography variant="h4" fontWeight="medium">
      {children}
    </Typography>
  );
}
